import React from "react";
import { XCircleIcon } from "@phosphor-icons/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteConversation } from "api/conversations";
import { useFeedback } from "contexts/feedback";
import { useNavigate, useParams } from "react-router-dom";
import Button from "components/Button";

export default function ConversationDeletePopup({
    visible,
    setVisible,
    conversation
}) {

    const cache = useQueryClient();
    const navigate = useNavigate();
    const params = useParams();
    const { setSuccess, setError } = useFeedback();

    const { mutate, isPending, isSuccess, isError } = useMutation({
        mutationKey: ['deleteConversation'],
        mutationFn: deleteConversation,
        onSuccess: () => {
            setSuccess('Conversazione eliminata con successo');
            cache.invalidateQueries(['conversations']);

            setTimeout(() => {
                setVisible(false);
                // Se siamo nella conversazione che stiamo eliminando, redirect alla dashboard
                if (params.conversationId === conversation._id) {
                    navigate('/');
                }
            }, 1000);
        },
        onError: (error) => {
            console.error("Error deleting conversation:", error);
            setError('Errore durante l\'eliminazione della conversazione');
        }
    });

    const getButtonStatus = () => {
        if (isPending) return 'pending';
        if (isSuccess) return 'success';
        if (isError) return 'error';
        return 'idle';
    };

    const confirmDelete = () => {
        mutate({ id: conversation._id });
    }

    if (!visible) return null;

    return (
        <div className="fixed z-[var(--z-modal)] flex top-0 left-0 lg:left-[320px] right-0 bottom-0 items-center justify-center transition-all backdrop-blur-sm">
            <div className="absolute top-0 left-0 right-0 bottom-0 bg-white/20 transition-all duration-300 ease-in-out flex items-center justify-center" onClick={() => setVisible(false)}></div>

            <div className="relative max-w-[90vw] w-full max-w-[450px] bg-white rounded-3xl transition-all duration-300 ease-in-out flex flex-col">
                <div className="w-full border-b border-black/6 px-6 py-4 flex justify-between items-center">
                    <p className="text-black font-medium">Elimina conversazione</p>

                    <div className="p-1" onClick={() => setVisible(false)}>
                        <XCircleIcon size={28} className="fill-black cursor-pointer hover:fill-black/80 transition-all duration-300 ease-in-out" />
                    </div>
                </div>

                <div className="px-6 py-6">
                    <p className="text-black mb-2">
                        Sei sicuro di voler eliminare la conversazione <strong>&quot;{conversation.name}&quot;</strong>?
                    </p>
                    <p className="text-black/60 text-sm">
                        Questa azione non può essere annullata.
                    </p>
                </div>

                <div className="flex border-t border-black/6">
                    <Button
                        className="flex-1 py-6 border-r border-black/6 rounded-none bg-white text-black hover:bg-black/10"
                        onClick={() => setVisible(false)}
                    >
                        Annulla
                    </Button>
                    <Button
                        className="flex-1 py-6 rounded-none bg-red-600 text-white hover:bg-red-700"
                        onClick={confirmDelete}
                        status={getButtonStatus()}
                        autoResetStatus={false}
                    >
                        Elimina
                    </Button>
                </div>
            </div>
        </div>
    )
}
